export default __webpack_public_path__ + "static/8339-c58d6637814bd3124450f862e3b836c7.jpg";